module.exports = __webpack_public_path__ + "img/product_6.b5f3a7b.webp";